import { Node, mergeAttributes } from '@tiptap/core';

export const EmojiNode = Node.create({
  name: 'emoji',
  inline: true,
  group: 'inline',
  selectable: false,
  atom: true,

  addAttributes() {
    return {
      unicode: { default: '' },
      shortcode: { default: '' },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-emoji]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, { 'data-emoji': HTMLAttributes.shortcode }), HTMLAttributes.unicode];
  },

  renderText({ node }) {
    return node.attrs.unicode;
  },
});
